module.exports = __webpack_public_path__ + "img/nuvola_1.f23027aa.png";